import type { ListingContract } from '~/types/hlx/msaasDetail';

export const WEEKEND_ROW_DATA_KEYS: {
  shiftType: string;
  diffKey: keyof ListingContract;
  countKey: keyof ListingContract;
  tableIdx: number;
}[] = [
  { shiftType: 'Day', diffKey: 'weDayShiftRateDiff', countKey: 'numOfWeDayShifts', tableIdx: 1 },
  {
    shiftType: 'Evening',
    diffKey: 'weEveShiftRateDiff',
    countKey: 'numOfWeEveShifts',
    tableIdx: 1,
  },
  {
    shiftType: 'Night',
    diffKey: 'weNightShiftRateDiff',
    countKey: 'numOfWeNightShifts',
    tableIdx: 1,
  },
];

export const HOLIDAY_ROW_DATA_KEYS: {
  shiftType: string;
  diffKey: keyof ListingContract;
  countKey: keyof ListingContract;
  tableIdx: number;
}[] = [
  { shiftType: 'Day', diffKey: 'holDayShiftRateDiff', countKey: 'numHolDayShifts', tableIdx: 2 },
  {
    shiftType: 'Evening',
    diffKey: 'holEveShiftRateDiff',
    countKey: 'numHolEveShifts',
    tableIdx: 2,
  },
  {
    shiftType: 'Night',
    diffKey: 'holNightShiftRateDiff',
    countKey: 'numHolNightShifts',
    tableIdx: 2,
  },
];
